module.exports = __webpack_public_path__ + "img/image-2.a53ddf27.jpeg";